// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"85":"8ece47b6","164":"9e0e238f","200":"a73316da","251":"3c2e6829","554":"9af590a4","815":"9da243c3","833":"a0660c4f","847":"ab2ce885"}[chunkId] + ".chunk.js";
};